import { Divider, Stack, Text } from "@mantine/core"
import type { FC, ReactNode } from "react"
import React from "react"
import { Trans } from "react-i18next"
import MenuOffersFilter from "../features/offers/components/MenuOffersFilter"
import type { Offer } from "../features/offersList/offersListTypes"
import type { FilterState, Option } from "../hooks/useOffersFilter"
import Card from "./Card"

interface OffersSidebarProps {
  offers: Offer[]
  categories: Option[]
  programs: Option[]
  tags: Option[]
  onFilterChange: (filters: FilterState) => void
  renderOfferItem: (offer: Offer, index: number) => ReactNode
  emptyMessage?: string
}

const OffersSidebar: FC<OffersSidebarProps> = ({
  offers,
  categories,
  programs,
  tags,
  onFilterChange,
  renderOfferItem,
  emptyMessage = "Nenhuma oferta encontrada correspondendo aos seus critérios.",
}) => {
  return (
    <div className="lg:w-1/3 md:w-1/2 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
      <Card title={<Trans i18nKey="newsletter.sidebar.titleOffers" />}>
        <div className="p-3">
          <MenuOffersFilter
            categoriesOptions={categories}
            programsOptions={programs}
            tagsOptions={tags}
            onFilterChange={onFilterChange}
          />
        </div>

        <div
          className="overflow-y-auto"
          style={{ maxHeight: 800, borderTop: "1px solid var(--mantine-color-gray-3)" }}
        >
          <Stack gap={0}>
            {offers.map((offer, index) => (
              <React.Fragment key={offer.CustomOfferID}>
                {renderOfferItem(offer, index)}
                {index < offers.length - 1 && <Divider />}
              </React.Fragment>
            ))}

            {offers.length === 0 && (
              <Text ta="center" c="dimmed" mt="xl" py="lg">
                {emptyMessage}
              </Text>
            )}
          </Stack>
        </div>
      </Card>
    </div>
  )
}

export default OffersSidebar